import { FloorClass } from '../../../models/floor.class';
import { NonRentableSpaceClass } from '../../../models/space/non-rentable-space.class';
import { AbstractSpaceClass } from '../../../models/space/abstract-space.class';
import { ReqDeleteNonRentableSpace } from './non-rentable-space.model';

type HowToDealWithNewSpaceFunction = (
  floorToReturn: FloorClass,
  nonRentableSpace: NonRentableSpaceClass
) => AbstractSpaceClass[];

export function addNewNonRentableSpace(
  floorsData: FloorClass[],
  floorNumber: string,
  nonRentableSpace: NonRentableSpaceClass,
  dealWithSpaceFn: HowToDealWithNewSpaceFunction
): FloorClass[] {
  return floorsData.map(floor => {
    let floorToReturn = floor;
    if (floor.floorNumber === floorNumber) {
      floorToReturn = floor.clone();
      floorToReturn.spaces = dealWithSpaceFn(floorToReturn, nonRentableSpace);
    }
    return floorToReturn;
  });
}

export function deleteNonRentableSpaceInfo(
  floorData: FloorClass[],
  propertyId: number,
  suiteId: number,
  currentFloorNumber: string
): ReqDeleteNonRentableSpace {
  const floorToDeleteNRSFrom = floorData.find(floor => floor.floorNumber === currentFloorNumber);
  const { floorId: floor_id } = floorToDeleteNRSFrom;
  return {
    property_id: propertyId,
    'request.source_id': propertyId,
    floor_id,
    suite_id: suiteId,
  };
}
